import PropTypes from 'prop-types'
import React, {
  createContext,
  useEffect,
  useState,
} from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom'
import { CONSTANTS } from 'src/constants'
import { getUserInfo } from 'src/api/user'

const UserContext = createContext({
  currentUser: null, setCurrentUser: () => {},
  userInfo: null, setUserInfo: () => {},
})

const UserContextProvider = ({ children }) => {
  const history = useHistory()
  const location = useLocation()

  const [currentUser, setCurrentUser] = useState()
  const [userInfo, setUserInfo] = useState(null)

  useEffect(() => {
    setCurrentUser(localStorage.getItem(CONSTANTS.CURRENT_USER))
  }, [])

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const userInfo = await getUserInfo()
        if (userInfo.id) {
          setUserInfo(userInfo)
        } else {
          console.error('Failed to download user data:', userInfo)
        }
      } catch (err) {
        console.error('API connection error:', err)
      }
    }

    const isLoggedIn = localStorage.getItem('USER_TOKEN')
    if (isLoggedIn) {
      fetchUserInfo()
    }
  }, [])

  useEffect(() => {
    const publicPages = ['/qrdownload', '/login', '/404', '/500','/api-docs']
    if (location.hash.startsWith('#/')) {
      window.location.replace(location.hash.replace(/#\/(.*)/, '$1'))
    } else if (!localStorage.getItem('USER_TOKEN') && publicPages.every(e => !location.pathname.startsWith(e))) {
      history.push({ pathname: '/login', from: location.pathname })
    }
  }, [location, history])

  return (
    <UserContext.Provider
      value={ { currentUser, setCurrentUser, userInfo, setUserInfo } }
    >
      { children }
    </UserContext.Provider>
  )
}

UserContextProvider.propTypes = {
  children: PropTypes.node,
}

export {
  UserContext,
  UserContextProvider,
}
